import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export const LegalLayout = ({ title, subtitle, description, children, canonical, testId }) => {
  return (
    <div className="App" data-testid={testId}>
      <Helmet>
        <title>{`${title} — All Day Power Washing`}</title>
        {description ? <meta name="description" content={description} /> : null}
        {canonical ? <link rel="canonical" href={canonical} /> : null}
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Header />
      <section className="pt-32 pb-12 bg-[#0B1726] border-b border-slate-900">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors font-heading uppercase text-xs tracking-widest mb-6"
          >
            <Home className="w-3.5 h-3.5" /> Back to home
          </Link>
          <div className="flex items-center gap-3 mb-3">
            <span className="h-px w-10 bg-[#1E88E5]" />
            <span className="font-heading text-xs font-bold tracking-[0.3em] uppercase text-[#E6B445]">
              {subtitle}
            </span>
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
            {title}
          </h1>
        </div>
      </section>

      <article className="bg-[#0B1726] py-16">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 prose prose-invert prose-slate max-w-none">
          {children}
        </div>
      </article>

      <Footer />
    </div>
  );
};
